import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlacementsListComponent } from './placements-list/placements-list.component';
import { PlacementsCreateComponent } from './placements-create/placements-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: PlacementsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: PlacementsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'placements-create/:id',
        component: PlacementsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlacementsRoutingModule { }
